import React, { useState } from 'react';

const SubtractionVisual: React.FC = () => {
    const [currentQuestion, setCurrentQuestion] = useState(generateQuestion());
    const [selectedOption, setSelectedOption] = useState<number | null>(null);
    const [showImage, setShowImage] = useState(false);


    document.title = "Mamas Guidance - Class Two - Mathematics - Subtraction - Visual Problem"; // Set page title

    // Function to generate a random question and options
    function generateQuestion() {
        const num1 = Math.floor(Math.random() * 900) + 100; // Random number from 1 to 9
        const num2 = Math.floor(Math.random() * 900) + 100; // Random number from 1 to 9
        const [larger, smaller] = num1 > num2 ? [num1, num2] : [num2, num1]; // Ensure non-negative result
        const correctAnswer = larger - smaller;

        // Generate options
        const options = new Set<number>();
        options.add(correctAnswer); // Ensure correct answer is included
        //while (options.size < 3) {
        options.add(correctAnswer + 10); // Random number up to 9
        options.add(correctAnswer - 10); // Random number up to 9
        //}
        return {
            num1: larger,
            num2: smaller,
            correctAnswer,
            options: Array.from(options).sort(() => Math.random() - 0.5), // Shuffle options
        };
    }

    // Handle answer selection
    const handleAnswer = (selectedAnswer: number) => {
        setSelectedOption(selectedAnswer);
        if (selectedAnswer === currentQuestion.correctAnswer) {
            setShowImage(true);
            setTimeout(() => {
                setCurrentQuestion(generateQuestion()); // Generate next question
                setShowImage(false);
                setSelectedOption(null);
            }, 5000);
        }
    };

    return (
        <>

            {showImage === false ? (
                <>
                    <div className="contentPart">
                        <div className="questionArea">
                            <div className='grid-container'>
                                <div className='grid-box text-right'>
                                    <div className="number-row" style={{opacity:'0'}}>-</div>
                                    <div className="number-row">-</div>
                                </div>
                                <div className='grid-box text-left'>
                                    <div className="number-row">{currentQuestion.num1}</div>
                                    <div className="number-row">{currentQuestion.num2}</div>
                                </div>
                            </div>
                            <div className='dividerClass'>
                                <hr className="divider" />
                            </div>
                            <div className='text-center'>
                                <div className="optionDiv">
                                    {currentQuestion.options.map((option, index) => (
                                        <div
                                            key={index}
                                            className={`background-blue ${
                                                selectedOption === option
                                                    ? option === currentQuestion.correctAnswer
                                                        ? 'correct'
                                                        : 'incorrect'
                                                    : ''
                                            }`}
                                            onClick={() => handleAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            ) : (
                <>
                    <div className="contentPart showMiddle">
                        <img
                            style={{ height: '150px' }}
                            className="img-fluid"
                            src={process.env.REACT_APP_WELDONE_LINK}
                            alt="Well Done"
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default SubtractionVisual;
